import angular from 'angular'

import authService from './services/auth.service'
import accountRequest from './services/request.service'
import accountResource from './services/resource.service'
import userService from './services/user.service'
import accountService from './services/account.service'
import accountMetadata from './services/metadata.service'
import accountData from './services/data.service'
import accountAsk from './services/ask.service'
import accountFormat from './services/format.service'

import accountButtons from './resources/buttons.resource'
import accountIcons from './resources/icons.resource'
import accountFields from './resources/fields.resource'
import accountLabels from './resources/labels.resource'

import myChangePasswordForm from './directives/myChangePasswordForm'
import myNewUserForm from './directives/myNewUserForm'

const name = 'account'
angular.module(name, [])
  .factory('authService', authService)
  .factory('accountRequest', accountRequest)
  .factory('accountResource', accountResource)
  .factory('userService', userService)
  .factory('accountMetadata', accountMetadata)
  .factory('$$account', accountService)
  .factory('accountData', accountData)
  .factory('accountAsk', accountAsk)
  .factory('accountFormat', accountFormat)

  .factory('accountButtons', accountButtons)
  .factory('accountIcons', accountIcons)
  .factory('accountFields', accountFields)
  .factory('accountLabels', accountLabels)

  .directive('myChangePasswordForm', myChangePasswordForm)
  .directive('myNewUserForm', myNewUserForm)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/account.module.js